import axios from "axios";
import getToken from "./getToken.js";
const URL = process.env.REACT_APP_BACKEND_USER_URL;

const GetUserSessionStatus = async () => {
  const userToken = getToken();
  try {
    const { status: response } = await axios.get(URL, {
      headers: {
        token: userToken
      },
    });
    return (response)
  } catch (error) {
    return error;
  }
};

export default GetUserSessionStatus;
